export const update_security_transition = `subscription update_security_transition{
    update_security_transition{
        transaction_code
        status
        from_account
        to_account
        amount
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        transfer_date
        fulfillment_date
    }
}`;
